import { useCallback, useState } from 'react';

export const useToggle = (defaultValue = false) => {
  const [val, setVal] = useState(defaultValue);

  const toggle = useCallback(() => {
    setVal((prev) => !prev);
  }, []);

  return { val, toggle };
};
